module.exports = __webpack_public_path__ + "static/media/MIX_START_FAST.f86ba6ab.mp3";